import { Map } from 'immutable';
import { ARTICLE } from '@constants/actions';

const initialState = Map({
  articleList: undefined,
  totalCount: 0,
  selectedArticle: undefined,
});

const Article = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type) {
    case ARTICLE.POPULATE:
      return state.set('articleList', actionPayload.articles)
        .set('totalCount', actionPayload.totalCount);
    case ARTICLE.SELECTED:
      return state.set('selectedArticle', actionPayload.selectedArticle);
    case ARTICLE.RESET:
      return initialState;
    default:
      return state;
  }
};

export default Article;